import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { filterByProject } from '../features/filter/filterSlice'

export default function ProjectList({ project }) {
    const dispatch = useDispatch()
    const { projectName, colorClass } = project || {}
    const [checkBoxValue, setCheckBoxValue] = useState(true)

    function handleChange(name) {
        dispatch(filterByProject(name))
    }

    return (
        <div className="checkbox-container">
            <input id={project.id} type="checkbox" className={colorClass} onChange={e => {
                setCheckBoxValue(e.target.checked)
                handleChange(projectName)
            }} checked={checkBoxValue} />
            <label htmlFor={project.id} className="label">{projectName}</label>
        </div>
    )
}
